import { computed } from 'vue'
import { useFeatureFlags } from '@/Hooks/Company/useFeatureFlags.js'

export function usePhotographerBrandingName() {
  const { hasFeatureFlag } = useFeatureFlags()

  const photographerBrandingName = computed(() =>
    hasFeatureFlag('hd_photos_rebrand')
      ? 'Photographer Branding & Enhanced Media'
      : 'Photographer Branding and HD Photos'
  )

  return { photographerBrandingName }
}
